export default {
    title: 'Clipboard',
    empty: 'Clipboard is empty. Add a QR from ticketset, device or zone editing.',
    print: 'Print sheet',
    clear: 'Clear',
    remove: 'Remove',
    split: 'Split',
    addPage: 'Add page',
    urlInQr: 'URL in QR code',
    dragHandle: 'Move (drag)',
    pageBreak: {
        placeholder: 'Page {n}',
        remove: 'Remove page',
        empty: 'Empty page'
    },
    merge: {
        deniedKindMismatch: 'Cannot merge (different types)',
        deniedSameLogin: 'Cannot merge two logins',
        success: 'Codes merged',
        loginAttached: 'Login attached'
    },
    printLabel: {
        add: 'Add custom label',
        placeholder: 'Custom print label',
        hint: 'Used instead of the name list when printing'
    },
    service: {
        addButton: 'Service code',
        addedToast: '+1 to clipboard: {label}',
        modal: {
            title: 'Service QR codes',
            close: 'Close'
        },
        groups: {
            reader: 'Reader settings',
            scanner: 'Scanner settings',
            hwOnlyBadge: 'HW reader only'
        },
        hwOnlyCard: 'Works only on the HW reader',
        // Modal uses sub-headings + short variant tiles. The card and print path
        // continue to use the full labels (e.g. server.prod = 'SERVER prod').
        server: {
            heading: 'SERVER',
            prod: 'SERVER prod',
            test: 'SERVER test',
            short: { prod: 'production', test: 'test' },
            subtitle: 'Switch reader to production / test server'
        },
        counter: {
            heading: 'COUNTER',
            on: 'COUNTER on',
            off: 'COUNTER off',
            short: { on: 'on', off: 'off' },
            subtitle: 'Scanned ticket counter in the UI'
        },
        display: {
            heading: 'DISPLAY',
            label: 'DISPLAY {pct}%',
            short: '{pct}%',
            subtitle: 'Reader display brightness'
        },
        // Language name is translated into the active locale (exonym).
        language: {
            heading: 'LANGUAGE',
            cs: 'LANGUAGE czech',
            en: 'LANGUAGE english',
            sk: 'LANGUAGE slovak',
            de: 'LANGUAGE german',
            pl: 'LANGUAGE polish',
            hu: 'LANGUAGE hungarian',
            hr: 'LANGUAGE croatian',
            short: {
                cs: 'czech',
                en: 'english',
                sk: 'slovak',
                de: 'german',
                pl: 'polish',
                hu: 'hungarian',
                hr: 'croatian'
            },
            subtitle: 'Switch UI language'
        },
        scanInfo: {
            heading: 'SCAN-INFO',
            none: 'SCAN-INFO none',
            price: 'SCAN-INFO price',
            ticketset: 'SCAN-INFO ticketset',
            'ticketset-price': 'SCAN-INFO ticketset + price',
            short: {
                none: 'show nothing',
                price: 'price only',
                ticketset: 'ticketset only',
                'ticketset-price': 'ticketset & price'
            },
            subtitle: 'What is shown after scanning a ticket'
        },
        wifi: {
            heading: 'WIFI',
            tile: 'WIFI',
            expandHint: 'Click and fill SSID + password',
            ssidLabel: 'SSID',
            passwordLabel: 'Password',
            addBtn: 'Add to clipboard',
            label: 'WIFI: {ssid}',
            subtitle: 'Wi-Fi connection'
        },
        startUpdate: {
            heading: 'START-UPDATE',
            label: 'Firmware update',
            short: 'run',
            subtitle: 'Starts reader firmware update'
        },
        reset: {
            heading: 'RESET',
            label: 'Factory reset ⚠',
            short: 'factory reset ⚠',
            subtitle: 'Wipes all reader settings'
        }
    }
}
